// Orientation
import React, { useEffect, useState, useRef } from "react";
import { Footer } from '../../components/footer/Footer';
import './OrientationVideoPage.scss';

function OrientationPage() {
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentVideo, setCurrentVideo] = useState<number>(0); 
  const videoRef = useRef<HTMLVideoElement | null>(null);
 
  /*
  "/video/TO DO: Add Content Here.mov",
    "/video/TO DO: Add Content Here.mp4",
    "https://TO DO: Add Content Here.mp4"
    "/video/TO DO: Add Content Here" - file is ng
  */
  const videos = [
    "https://cmwmediawus.azureedge.net/b9ea4413-c9c6-4997-8604-3e0ea350a8b8/3_Coach_Anne_Howard_GDS_Instructions_AI_H264_3400kbps_AAC_128kbps.mp4",
    "https://cmwmediawus.azureedge.net/ec4f2b18-ba1b-4b2c-b03c-3149062b4893/HPT_Overview_H264_3400kbps_AAC_128kbps.mp4"
  ];

  const titles = [
    "1 - Coach G -Instructions" ,
    "2 - HPT Overview"
  ]

  const togglePlayPause = () => {
    if (videoRef.current) {

      if (videoRef.current.paused) {
        videoRef.current.muted = false; // ⬅️ Required for iOS autoplay
        videoRef.current.play()
          .then(() => setIsPlaying(true))
          .catch((err) => {
            console.error("❌ Play failed:", err);
            setErrorMessage("Unable to start video playback.");
          });
      }

    }  
  };

  const changeVideo = (direction: "prev" | "next") => {
    console.log(`🔄 Change Video Triggered: ${direction}`);
    const newIndex =
      direction === "next"
        ? (currentVideo + 1) % videos.length
        : (currentVideo - 1 + videos.length) % videos.length;
    console.log(`➡️ New Video Index: ${newIndex}, Video: ${videos[newIndex]}`);
    setCurrentVideo(newIndex);
    setIsPlaying(false);
  };

  useEffect(() => {
    if (videoRef.current) {
      console.log("🎬 Setting initial video...");
      const video = videoRef.current;
      videoRef.current.src = videos[0];
      videoRef.current.load();
      videoRef.current.pause();
      setIsPlaying(false);

      // ⬇️ Restore button on end/pause
      const handlePauseOrEnd = () => setIsPlaying(false);
      video.addEventListener("pause", handlePauseOrEnd);
      video.addEventListener("ended", handlePauseOrEnd);

    return () => {
      video.removeEventListener("pause", handlePauseOrEnd);
      video.removeEventListener("ended", handlePauseOrEnd);
    };


    }
  }, []);

  useEffect(() => {
    if (!videoRef.current) {
      console.error("❌ videoRef.current is null, skipping update.");
      return;
    }

    console.log(`🎥 Updating video source to: ${videos[currentVideo]}`);
    videoRef.current.src = videos[currentVideo];
    videoRef.current.load();
    videoRef.current.pause();
    setIsPlaying(false);
  }, [currentVideo]);

  /* Infinite Scrolling */
  const containerRef = useRef<HTMLDivElement>(null); // Continuous infinite scroll state

  const [items, setItems] = useState(
    Array.from({ length: 10 }, (_, i) => `Signup Item ${i + 1}`)
  );

  const loadMoreItems = () => {
    setItems(prevItems => [
      ...prevItems,
      ...Array.from({ length: 10 }, (_, i) => `Signup Item ${prevItems.length + i + 1}`)
    ]);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

      if (scrollTop + clientHeight >= scrollHeight - 10) {
        loadMoreItems();
      }
    };

    /* HEY const container = containerRef.current;
    if (container) {
      //console.log("✅ Scroll to top on load");
      container.addEventListener("scroll", handleScroll, { passive: true });
    }*/

    return () => {
      /*if (container) {
        container.removeEventListener("scroll", handleScroll);
      }*/
    };
  }, []);

  /* Handle Form */
  const handleOrientationPage = (event: { preventDefault: () => void; }) => {
    event.preventDefault();
  };

  return (
    <div id="orientationPageContainer" className="orientationPageContainer" ref={containerRef}>
      <div id="orientationContainer" className="orientationContainer">
        {/* Error Message Display */}
        {errorMessage && <div className="errorStatus">{errorMessage}</div>}

        <div className="orientationTitle">HPT Orientation Videos</div>

        {/* Full Screen Video */}
        <div className="orientationVideoContainer">
          <br />
          <div className="video-zone">
            {/* Video Navigation */}
           {/* <div id="orientation-video-nav-container" className="orientation-video-nav-container">
             
              <button className="video-nav play" onClick={() => togglePlayPause()}>
                <i className={`fas ${isPlaying ? "fa-pause" : "fa-play"}`}></i>
              </button>

            </div>*/}

            {/* Video Element with Play Button */}
            <div className="video-wrapper">
              {!isPlaying && !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && (// Hide play icon on ios - they have a built in one
                 <button className="initial-play-button" onClick={togglePlayPause} aria-label="Play video">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" preserveAspectRatio="xMidYMin slice">
                    <g fill="none" fillRule="evenodd">
                      <circle cx="18" cy="18" r="17" stroke="#fff" strokeWidth="2"></circle>
                      <path fill="#fff" d="m23.935 17.708-10.313 6.033V11.676z"></path>
                    </g>
                  </svg>
                </button>
              )}

            <video
              id="orientation-video-player"
              //className={`orientation-video-player ${currentVideo === 1 ? 'portrait-fix' : ''}`}
              className={`orientation-video-player portrait-fix${currentVideo === 1 ? 'landscape-fix' : ''}`}
              key={currentVideo}
              ref={(el) => {
                videoRef.current = el;
              }}
              playsInline
              preload="auto"
              loop
              controls
            >
              <source src={videos[currentVideo]} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            </div>
          </div>
        </div>
        {/* Orientation Text */}
        <div id="orienationTextContainer" className="orienationTextContainer">
          <div id="orientationText" className="orientationText">
            {titles[currentVideo]}
          </div>

        </div>
      {/* Page Control Buttons */}
        <div className="orientationButtonContainer align-center">
            {/*<button className="orientationPrevButton" onClick={() => window.history.back()}>
              Go Back
            </button>*/}

            {/* Opened in a new tab (target=_blank) there is no history: close the tab instead; a
                browser that refuses the close lands on "/" rather than staying put. */}
            <button className="OrientationSignInButton" onClick={() => {
              if (window.history.length > 1) { window.history.back(); return; }
              window.close();
              setTimeout(() => { if (!window.closed) window.location.href = '/'; }, 300);
            }}>
            Go Back
            </button>
      </div>

      {/* Video Control Buttons*/}
        <div id="orientation-video-channel-container" className="orientation-video-channel-container">
            <button className="video-nav left" onClick={() => changeVideo("prev")}>
            <i className="fas fa-chevron-left"></i>
            </button>

            <button className="video-nav right" onClick={() => changeVideo("next")}>
            <i className="fas fa-chevron-right"></i>
            </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default OrientationPage;

